import type { StyleSheet, JssStyle, Styles } from 'jss';
import type { Nullable, Uuid } from '@common/types';

import { Injectable } from '@angular/core';
import jss from 'jss';

export type GeneratedStyles = Record<Uuid, StyleSheet>;

enum StyleType {
    widget = 'widget',
    container = 'container',
    structure = 'structure',
    section = 'section',
    block = 'block',
    preset = 'preset',
    column = 'column',
}

@Injectable({
    providedIn: 'root',
})
export class BaseStylesService {
    private styles: Record<StyleType, GeneratedStyles> = {
        container: {},
        widget: {},
        structure: {},
        block: {},
        preset: {},
        column: {},
        section: {},
    };

    private createStyle(id: Nullable<Uuid>, type: StyleType, styles: JssStyle): StyleSheet {
        if (this.styles[type][id]) {
            this.removeStyle(id, type, this.styles[type][id]);
        }

        const sheet = jss.createStyleSheet(styles as any, { link: true, meta: id ? `${type}-${id}` : type }).attach();

        if (id || type !== StyleType.preset) {
            this.styles[type][id] = sheet;
        }

        return sheet;

        // if (this.styles[type][id]) {
        //     this.removeStyle(id, type, this.styles[type][id]);
        // }

        // const sheet = jss.createStyleSheet(styles, { link: true }).attach();

        // if (id || type !== StyleType.preset) {
        //     this.styles[type][id] = sheet;
        // }

        // return sheet;
    }

    private removeStyle(id: Nullable<Uuid>, type: StyleType, sheet: StyleSheet): void {
        setTimeout(() => {
            sheet.detach();
        }, 300); // TODO: TRY TO REMOVE THIS SET TIMEOUT

        if (!id) {
            return;
        }

        delete this.styles[type][id];
    }

    public createWidgetStyle(elementId: Uuid, styles: JssStyle): StyleSheet {
        return this.createStyle(elementId, StyleType.widget, styles);
    }

    public createStructureStyle(structureId: Uuid, styles: JssStyle): StyleSheet {
        return this.createStyle(structureId, StyleType.structure, styles);
    }

    public createContainerStyle(containerId: Uuid, styles: JssStyle): StyleSheet {
        return this.createStyle(containerId, StyleType.container, styles);
    }

    public createBlockStyle(blockId: Uuid, styles: JssStyle): StyleSheet {
        return this.createStyle(blockId, StyleType.block, styles);
    }

    public createSectionStyle(sectionId: Uuid, styles: JssStyle): StyleSheet {
        return this.createStyle(sectionId, StyleType.section, styles);
    }

    public createColumnStyle(columnId: Uuid, styles: JssStyle): StyleSheet {
        return this.createStyle(columnId, StyleType.column, styles);
    }

    public createPresetStyle(styles: JssStyle): StyleSheet {
        return this.createStyle(null!, StyleType.preset, styles);
    }

    public removeWidgetStyle(elementId: Uuid, styles: StyleSheet): void {
        this.removeStyle(elementId, StyleType.widget, styles);
    }

    public removeContainerStyle(containerId: Uuid, styles: StyleSheet): void {
        this.removeStyle(containerId, StyleType.container, styles);
    }

    public removeBlockStyle(blockId: Uuid, styles: StyleSheet): void {
        this.removeStyle(blockId, StyleType.block, styles);
    }

    public removeSectionStyle(sectionId: Uuid, styles: StyleSheet): void {
        this.removeStyle(sectionId, StyleType.section, styles);
    }

    public removePresetStyle(styles: StyleSheet): void {
        this.removeStyle(null, StyleType.preset, styles);
    }

    public removeColumnStyle(columnId: Uuid, styles: StyleSheet): void {
        this.removeStyle(columnId, StyleType.column, styles);
    }

    public removeStructureStyle(structureId: Uuid, styles: StyleSheet): void {
        this.removeStyle(structureId, StyleType.structure, styles);
    }

    public getStyles(): GeneratedStyles {
        return { ...this.styles.container, ...this.styles.widget };
    }
}
